export default __webpack_public_path__ + "static/media/payment.8a1a443d.jpg";